import React from "react"
import { Link } from "gatsby"
import ShubhamKumarGautamImg from "../img/shubham-kumar-gautam.jpg"
import RavishRajImg from "../img/ravish-raj.jpg"
import NavtoshDasImg from "../img/navtosh-kumar.jpg"
import SuyashNamdeoImg from "../img/suyash-namdeo.jpg"
import ChiranjeevKumarImg from "../img/chiranjeev-kumar.jpg"
import KeshavNandanImg from "../img/keshav-nandan.jpg"

export default class Team extends React.Component {
  render() {
    return (
      <div className="mt-20">
        <div className="text-center">
          <h3 className="text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
            Our Team
          </h3>
        </div>

        <div className="grid gap-20 mx-5 mt-12 sm:mx-40 md:grid-cols-2 lg:grid-cols-3 lg:max-w-none">
          <div className="flex flex-col items-center justify-center p-4 mx-0 bg-white rounded-lg shadow">
            <div className="inline-flex w-40 h-40 overflow-hidden border border-gray-200 rounded-full shadow-lg">
              <img
                src={ShubhamKumarGautamImg}
                alt=""
                className="w-full h-full"
              />
            </div>

            <h2 className="mt-4 text-xl font-bold">Shubham Gautam</h2>
            <h6 className="mt-2 text-sm font-medium text-center">
              Mentoring Youth For Success
            </h6>
            <h6 className="mt-2 text-sm font-medium text-center">
              Founder | Super 30 | IIT BHU
            </h6>

            <ul className="flex flex-row -mt-3 space-x-2">
              <li>
                <a
                  href="https://www.linkedin.com/in/shubhamsuper30/"
                  className="ml-6 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Linkedin</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="50"
                    height="50"
                    viewBox="0 0 48 48"
                    className="w-8 h-8"
                  >
                    <path
                      fill="#0288D1"
                      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center p-4 mx-0 bg-white rounded-lg shadow">
            <div className="inline-flex w-40 h-40 overflow-hidden border border-gray-200 rounded-full shadow-lg">
              <img src={RavishRajImg} alt="" className="w-full h-full" />
            </div>

            <h2 className="mt-4 text-xl font-bold">Ravish Raj</h2>
            <h6 className="mt-2 text-sm font-medium text-center">
              Product Mentor
            </h6>
            <h6 className="mt-2 text-sm font-medium text-center">
              KPIT | Super 30 | IIT Kanpur
            </h6>

            <ul className="flex flex-row -mt-3 space-x-2">
              <li>
                <a
                  href="https://www.linkedin.com/in/ravishkumar2/"
                  className="ml-6 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Linkedin</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="50"
                    height="50"
                    viewBox="0 0 48 48"
                    className="w-8 h-8"
                  >
                    <path
                      fill="#0288D1"
                      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center p-4 mx-0 bg-white rounded-lg shadow">
            <div className="inline-flex w-40 h-40 overflow-hidden border border-gray-200 rounded-full shadow-lg">
              <img src={ChiranjeevKumarImg} alt="" className="w-full h-full" />
            </div>

            <h2 className="mt-4 text-xl font-bold">Chiranjeev Kumar</h2>
            <h6 className="mt-2 text-sm font-medium text-center">
              Product Mentor
            </h6>
            <h6 className="mt-2 text-sm font-medium text-center">
              Amazon | Super 30 | IIT BHU
            </h6>

            <ul className="flex flex-row -mt-3 space-x-2">
              <li>
                <a
                  href="https://www.linkedin.com/in/kumarchiranjeev/"
                  className="ml-6 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Linkedin</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="50"
                    height="50"
                    viewBox="0 0 48 48"
                    className="w-8 h-8"
                  >
                    <path
                      fill="#0288D1"
                      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center p-4 mx-0 bg-white rounded-lg shadow">
            <div className="inline-flex w-40 h-40 overflow-hidden border border-gray-200 rounded-full shadow-lg">
              <img src={KeshavNandanImg} alt="" className="w-full h-full" />
            </div>

            <h2 className="mt-4 text-xl font-bold">Keshav Nandan</h2>
            <h6 className="mt-2 text-sm font-medium text-center">
              Product Mentor
            </h6>
            <h6 className="mt-2 text-sm font-medium text-center">
              Uber | Super 30 | IIT BHU
            </h6>

            <ul className="flex flex-row -mt-3 space-x-2">
              <li>
                <a
                  href="https://www.linkedin.com/in/keshav-nandan-58871b26/"
                  className="ml-6 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Linkedin</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="50"
                    height="50"
                    viewBox="0 0 48 48"
                    className="w-8 h-8"
                  >
                    <path
                      fill="#0288D1"
                      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center p-4 mx-0 bg-white rounded-lg shadow">
            <div className="inline-flex w-40 h-40 overflow-hidden border border-gray-200 rounded-full shadow-lg">
              <img src={NavtoshDasImg} alt="" className="w-full h-full" />
            </div>

            <h2 className="mt-4 text-xl font-bold">Navtosh Kumar</h2>
            <h6 className="mt-2 text-sm font-medium text-center">
              Core Team Member
            </h6>
            <h6 className="mt-2 text-sm font-medium text-center">IIT BHU</h6>

            <ul className="flex flex-row -mt-3 space-x-2">
              <li>
                <a
                  href="https://www.linkedin.com/in/navtosh-kumar/"
                  className="ml-6 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Linkedin</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="50"
                    height="50"
                    viewBox="0 0 48 48"
                    className="w-8 h-8"
                  >
                    <path
                      fill="#0288D1"
                      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center p-4 mx-0 bg-white rounded-lg shadow">
            <div className="inline-flex w-40 h-40 overflow-hidden border border-gray-200 rounded-full shadow-lg">
              <img src={SuyashNamdeoImg} alt="" className="w-full h-full" />
            </div>

            <h2 className="mt-4 text-xl font-bold">Suyash Namdeo</h2>
            <h6 className="mt-2 text-sm font-medium text-center">
              Core Team Member
            </h6>
            <h6 className="mt-2 text-sm font-medium text-center">
              IIT Kharagpur
            </h6>

            <ul className="flex flex-row -mt-3 space-x-2">
              <li>
                <a
                  href="https://www.linkedin.com/in/suyash-namdeo-433109151/"
                  className="ml-6 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Linkedin</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="50"
                    height="50"
                    viewBox="0 0 48 48"
                    className="w-8 h-8"
                  >
                    <path
                      fill="#0288D1"
                      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
